import store from '@state/store'

export default (routeTo, routeFrom, next) => {
  store.dispatch('auth/logOut')

  const authRequiredOnPreviousRoute = routeFrom.matched.some(
    (route) => route.meta.authRequired
  )

  // Navigate back to previous page, or member login page as a fallback
  next(
    authRequiredOnPreviousRoute ? { name: 'member-login' } : { ...routeFrom }
  )
}
